module.exports = __webpack_public_path__ + "static/media/TAN-logo.abbaa0a8.png";